import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RelationDto } from './relation-dto';


export class AllRelationsResponseModel extends GlobalResponseObject {
    data?: RelationDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: RelationDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

